<style scoped src="../../../css/selector-base.less" lang="less"></style>
<style lang="less" scoped>
  .select-item-container{
    overflow: auto;
    max-height: 160px;
  }
</style>
<template>
  <v-autocomplete
    v-bind="$attrs"
    :items="items"
    :clearable="clearable"
    item-value="id"
    item-text="full_name"
    :rules="$attrs.rules"
    v-on="$listeners"
  >
    <template v-slot:label> 
      <span><span
        v-show="$attrs.required"
        style="color:red"
      >*</span>{{ $attrs.label }}</span>
    </template>
  </v-autocomplete>
</template>
<script>
  import ExpenseTypeUtil from '../../expense_type/libs/util';
  export default {
    inheritAttrs: false,
    props: {
      clearable: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        items: [],
        loading: false
      }
    },
    created() {
      this.getUsedExpenseTypes();
    },
    mounted() {
      //
    },
    methods: {
      getUsedExpenseTypes() {
        if (this.loading) return;
        this.loading = true;
        this.items = [];
        ExpenseTypeUtil.getUsedLastGenerationTypes().then((data) => {
          data.expense_types.forEach((type) => {
            this.items.push(type);
          });
        }).catch((e) => {
          this.$Modal.error({title:'错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        })
      },
    }
  }
</script>
